module.exports = __webpack_public_path__ + "img/v1_woman.395ee0eb.svg";